// ============================================================================
// Setup Page — shown when Cognito is not configured
// ============================================================================

export function SetupPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-brand-green to-brand-green-700 px-4">
      <div className="w-full max-w-lg">
        {/* Logo / Title */}
        <div className="mb-8 text-center">
          <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-xl bg-white text-brand-green font-bold text-xl shadow-lg">
            CCM
          </div>
          <h1 className="text-2xl font-bold text-white">
            Social Media Manager
          </h1>
          <p className="mt-1 text-sm text-brand-green-200">
            Cream City Mortgage
          </p>
        </div>

        {/* Setup Instructions */}
        <div className="card p-6 shadow-xl">
          <div className="mb-4 flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-yellow-100 text-yellow-600">
              ⚠️
            </div>
            <h2 className="text-lg font-semibold text-gray-900">
              Setup Required
            </h2>
          </div>

          <p className="mb-4 text-sm text-gray-600">
            Authentication is not configured. To use this application, you need to deploy the
            backend infrastructure and set the following environment variables:
          </p>

          <div className="mb-4 rounded-lg bg-gray-50 p-4 font-mono text-xs text-gray-700">
            <p className="mb-1"><span className="text-brand-green font-semibold">VITE_COGNITO_USER_POOL_ID</span>=us-east-1_XXXXX</p>
            <p className="mb-1"><span className="text-brand-green font-semibold">VITE_COGNITO_CLIENT_ID</span>=your-client-id</p>
            <p className="mb-1"><span className="text-brand-green font-semibold">VITE_COGNITO_REGION</span>=us-east-1</p>
            <p><span className="text-brand-green font-semibold">VITE_API_URL</span>=https://your-api-url.amazonaws.com/dev</p>
          </div>

          <div className="space-y-3 text-sm text-gray-600">
            <p><strong>Steps:</strong></p>
            <ol className="list-decimal space-y-2 pl-5">
              <li>
                Deploy the CDK stacks:
                <code className="ml-1 rounded bg-gray-100 px-1.5 py-0.5 text-xs">
                  cd cdk && npx cdk deploy --all
                </code>
              </li>
              <li>
                Copy the outputs (UserPoolId, UserPoolClientId, ApiUrl) into your
                <code className="mx-1 rounded bg-gray-100 px-1.5 py-0.5 text-xs">
                  frontend/.env
                </code>
                file.
              </li>
              <li>
                Create your first user:
                <code className="ml-1 block mt-1 rounded bg-gray-100 px-1.5 py-0.5 text-xs">
                  aws cognito-idp admin-create-user --user-pool-id YOUR_POOL_ID --username user@email.com --temporary-password TempPass123!
                </code>
              </li>
              <li>Restart the dev server or rebuild.</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
}
